import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {FileManagementService} from '@core/services/file-management.service';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export  class ManageWorkspaceSolutionCommandHandler implements IPlatformCommandHandler {
  constructor(private commandService: CommandService) {
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    if (command.fieldValues['OpenInNewTab']){
      window.open(command.fieldValues['OpenInNewTab'], '_blank', 'noreferrer')
      return;
    }
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
      handler.invalidateSubject.invalidate('Refresh');
    });
    return false;
  }
}
